// Define the order and nesting of source of funds filters.

const filterSourceOfFundsOptions = [
  {
    children: [],
    slug: 'allSources',
    suppress: [3],
  },
  {
    children: [
      {
        children: [],
        slug: 'privateHealthInsurance',
        suppress: [],
      },
      {
        children: [],
        slug: 'chip',
        suppress: [],
      },
      {
        children: [],
        slug: 'departmentOfDefense',
        suppress: [],
      },
      {
        children: [],
        slug: 'departmentOfVeteransAffairs',
        suppress: [],
      },
      {
        children: [],
        slug: 'medicaid',
        suppress: [],
      },
      {
        children: [],
        slug: 'medicare',
        suppress: [],
      },
    ],
    slug: 'healthInsurance',
    suppress: [],
  },
  {
    children: [],
    slug: 'outOfPocket',
    suppress: [],
  },
  {
    children: [
      {
        children: [],
        slug: 'worksiteHealthCare',
        suppress: [],
      },
      {
        children: [],
        slug: 'otherPrivateRevenues',
        suppress: [],
      },
      {
        children: [],
        slug: 'indianHealthServices',
        suppress: [],
      },
      {
        children: [],
        slug: 'workersCompensation',
        suppress: [],
      },
      {
        children: [],
        slug: 'generalAssistance',
        suppress: [],
      },
      {
        children: [],
        slug: 'maternalChildHealth',
        suppress: [],
      },
      {
        children: [],
        slug: 'vocationalRehabilitation',
        suppress: [],
      },
      {
        children: [],
        slug: 'otherFederalPrograms',
        suppress: [],
      },
      {
        children: [],
        slug: 'samhsa',
        suppress: [],
      },
      {
        children: [],
        slug: 'otherStateAndLocalPrograms',
        suppress: [],
      },
      {
        children: [],
        slug: 'schoolHealth',
        suppress: [],
      },
    ],
    slug: 'otherThirdParty',
    suppress: [],
  },
  {
    children: [
      {
        children: [],
        slug: 'federal',
        suppress: [],
      },
      {
        children: [],
        slug: 'stateAndLocal',
        suppress: [],
      },
    ],
    slug: 'publicHealthActivity',
    suppress: [2, 3],
  },
  {
    children: [],
    slug: 'totalCMSPrograms',
    suppress: [2, 3],
  },
  {
    children: [
      {
        children: [],
        slug: 'research',
        suppress: [],
      },
      {
        children: [],
        slug: 'structuresAndEquipment',
        suppress: [],
      },
      {
        children: [],
        slug: 'structures',
        suppress: [],
      },
    ],
    slug: 'investment',
    suppress: [2, 3],
  },
];

export default filterSourceOfFundsOptions;
